<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m9.643 8 5.012-5A1.17 1.17 0 1 0 13 1.345L8 6.356 3 1.345A1.17 1.17 0 1 0 1.345 3l5.012 5-5.012 5a1.166 1.166 0 0 0 0 1.655 1.167 1.167 0 0 0 1.655 0l5-5.012 5 5.012a1.165 1.165 0 0 0 1.655 0 1.166 1.166 0 0 0 0-1.655L9.643 8Z"
      fill="currentColor"
    />
  </svg>
</template>
